/**
 * 登录页面
 * 账号由管理员创建，不提供自助注册
 */

import { useState } from "react";
import {
  Form,
  Input,
  Button,
  Card,
  Typography,
  App,
  Alert,
} from "antd";
import { LockOutlined, UserOutlined } from "../components/icons";
import { signIn } from "../lib/auth-client";
import logo from "../assets/logo.svg";

const { Title, Text } = Typography;

interface AuthFormValues {
  username: string;
  password: string;
}

export function AuthPage() {
  const [loading, setLoading] = useState(false);
  const { message: globalMessage } = App.useApp();

  const handleLogin = async (values: AuthFormValues) => {
    setLoading(true);
    try {
      const { error } = await signIn.username({
        username: values.username,
        password: values.password,
      });

      if (error) {
        globalMessage.error(error.message || "登录失败");
      } else {
        globalMessage.success("欢迎回来！");
      }
    } catch {
      globalMessage.error("登录时发生错误，请稍后重试");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gradient">
      <Card
        className="glass-effect shadow-2xl"
        style={{ width: 420, maxWidth: "calc(100vw - 32px)", padding: "12px 12px 0" }}
        variant="borderless"
      >
        <div style={{ textAlign: "center", marginBottom: 24, marginTop: 12 }}>
          <img src={logo} alt="发单监控系统" style={{ width: 32, height: 32 }} />
          <Title
            level={3}
            style={{ margin: "0 0 8px", fontWeight: 700, color: "#1e293b" }}
          >
            发单监控系统
          </Title>
          <Text type="secondary" style={{ fontSize: 15 }}>
            多租户运营后台
          </Text>
        </div>

        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 20 }}
          message="账号由管理员创建"
          description="本系统不提供自助注册。如需开通或重置账号，请联系平台/租户管理员。"
        />

        <Form
          onFinish={handleLogin}
          autoComplete="off"
          layout="vertical"
          requiredMark={false}
        >
          <Form.Item
            name="username"
            rules={[
              { required: true, message: "请输入用户名" },
              { min: 3, message: "用户名至少 3 个字符" },
              {
                pattern: /^[a-zA-Z0-9_]+$/,
                message: "用户名只能包含字母、数字和下划线",
              },
            ]}
          >
            <Input
              prefix={<UserOutlined className="text-gray-400" />}
              placeholder="用户名"
              size="large"
              variant="filled"
              autoComplete="username"
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              { required: true, message: "请输入密码" },
              { min: 6, message: "密码至少 6 个字符" },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="text-gray-400" />}
              placeholder="密码"
              size="large"
              variant="filled"
              autoComplete="current-password"
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              size="large"
              className="shadow-md"
            >
              登录
            </Button>
          </Form.Item>
          <div style={{ textAlign: "center", paddingBottom: 8 }}>
            <Text type="secondary" style={{ fontSize: 13 }}>
              登录即表示你已了解账号由管理员统一分配与维护
            </Text>
          </div>
        </Form>
      </Card>
    </div>
  );
}
